/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowTriggerEventProcessDto } from '../../models/workflow-trigger-event-process-dto';
import { WorkflowTriggerEventProcessUpdateDto } from '../../models/workflow-trigger-event-process-update-dto';

export interface AutomatedProcessUpdateTriggerEventProcess$Params {
  id: number;
      body: WorkflowTriggerEventProcessUpdateDto
}

export function automatedProcessUpdateTriggerEventProcess(http: HttpClient, rootUrl: string, params: AutomatedProcessUpdateTriggerEventProcess$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowTriggerEventProcessDto>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessUpdateTriggerEventProcess.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkflowTriggerEventProcessDto>;
    })
  );
}

automatedProcessUpdateTriggerEventProcess.PATH = '/automated-process/workflow-trigger/trigger-event-process/{id}';